/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment, PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  path {
    fill: inherit;
  }
`
export default class ClubPortalIco extends PureComponent {
  render() {
    return (
      <Fragment>
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="38" viewBox="0 0 30 38" css={Color}>
          <path
            id="패스_3852"
            data-name="패스 3852"
            d="M156.37,233.133V203.29h17.042v2.72a2.08,2.08,0,1,0,4.16,0v-4.72q0-2.24-2.08-2.24h-21.2a1.98,1.98,0,0,0-2.24,2.24v33.923a1.98,1.98,0,0,0,2.24,2.24h21.2q2.08,0,2.08-2.24v-4.8q0-2.24-2.08-2.24t-2.08,2.24v2.72H156.37m5.041-14.8q0,1.76,1.92,1.76h11.521l-2.24,2.16q-1.44,1.44,0,2.56,1.28,1.44,2.4,0l5.521-5.361v-.16l.16-.16v-.16l.16-.16v-1.12l-.16-.16v-.16l-5.681-5.761a1.73,1.73,0,0,0-1.28-.48,1.535,1.535,0,0,0-1.12.48q-1.44,1.44,0,2.56l2.24,2.24H163.331a1.7,1.7,0,0,0-1.92,1.92"
            transform="translate(-152.05 -200)"
            fill="#1c202b"
          />
        </svg>
      </Fragment>
    )
  }
}
